import { makeStyles } from '@material-ui/core'

export const useSystemPromptsStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}))
